
import animations from './animations'

export {animations}

export const postAnimate = function (chart, selection) {
  // reverse the stacked area series in the DOM, this allows lower areas to be on top of the upper paths, so points (circles)
  // aren't covered by another path. We want to wait until transitions have finished so it doesn't flicker
  // if swapping series between a stacked area and normal area graph.
  selection.selectAll('g.serie.area').filter(serie => serie.stackBy)
           .sort(() => -1)
}
